<template>
  <v-btn
    :href="referralLinkWhitepaper"
    target="_blank"
    @click="captureReferralLink('referrallink_howto_whitepaper', referralLink); return false;"
    outlined
    small
    >https://wisetoken.net/teal/
  </v-btn>
</template>

<script>
import config from "@/utils/config.json";

export default {
  name: "ReferralLink",

  data() {
    return {
      referralAccount: config.referralAccount
    };
  },
  computed: {
    referralLinkWhitepaper() {
      return "https://wisetoken.net/teal/?w=" + config.referralAccount;
    },
  },
  methods: {
    captureReferralLink(category, url) {
      this.$ga.event(category, 'click', url, 1234);
    }
  }
};
</script>
